import { render, staticRenderFns } from "./UpdateMaxHoldLimitPopup.vue?vue&type=template&id=31bb6fb0&scoped=true&"
import script from "./UpdateMaxHoldLimitPopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateMaxHoldLimitPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateMaxHoldLimitPopup.vue?vue&type=style&index=0&id=31bb6fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb6fb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bb6fb0')) {
      api.createRecord('31bb6fb0', component.options)
    } else {
      api.reload('31bb6fb0', component.options)
    }
    module.hot.accept("./UpdateMaxHoldLimitPopup.vue?vue&type=template&id=31bb6fb0&scoped=true&", function () {
      api.rerender('31bb6fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/UpdateMaxHoldLimitPopup.vue"
export default component.exports